import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Form from "./Common_Form";
import {
  Create,
  GetAll,
} from "../../../../../features/admin/masters/method_of_testing/Slice";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";

const Add_User = ({
  show,
  handleClose,
  setShow,
  setSuccess,
  setErr,
}) => {
  const dispatch = useDispatch();

  const [showError, setShowError] = useState({});

 
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data.name);

      const res = await dispatch(Create(sendData));

      if (res?.payload?.success) {
        dispatch(GetAll());
        setShow(false);
        setSuccess(true);
        setShowError(null);
      } else {
        setShowError(res?.payload?.errors || {});
      }
    } catch (error) {
      console.error(error);
      setErr(true);
      setShow(false);
    }
  };
 

  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Add New Method Of Testing
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="add_form">
          <Common_Form
            onSubmit={onSubmit}
            handleClose={handleClose}
            showError={showError}
            success={false}
          />
        </div>
       
      </Offcanvas.Body>
    </Offcanvas>
    
  );
};

export default Add_User;
